export default __webpack_public_path__ + "static/media/screen_whatsapp_3.b72eaca3.png";